import styled from 'react-emotion';

export const BaseTable = styled.table`
	border-collapse: collapse;
	border-spacing: 0;
	font-size: 0.875rem;
	line-height: 2.5;
	text-align: center;
	width: 100%;

	thead {
		background-color: #e0e0e0;
	}

	th {
		font-weight: 400;
	}

	tbody tr:nth-child(odd) {
		background-color: #f2f2f2;
	}

	tbody tr:nth-child(even) {
		background-color: #fff;
	}
`;
